import { isValidPhoneNumber } from 'react-phone-number-input';
import * as Yup from 'yup';

import { DENIED_EMAIL_CHARS_REGEX, EMAIL_FORMAT } from 'constants/Email';

import { ContactInformationFields, IContactInformationFormValues } from './constants';

export const contactInformationFormValidationSchema = Yup.object<
  Yup.ObjectSchema<IContactInformationFormValues>
>().shape({
  [ContactInformationFields.BorrowerEmail]: Yup.string()
    .trim()
    .required('Email is required')
    .email('Invalid email')
    .matches(EMAIL_FORMAT, 'Invalid email')
    .test(
      'isEmailMatches',
      'Please use email address without special characters',
      (value: string) => {
        const includeDeniedChars = value.match(DENIED_EMAIL_CHARS_REGEX);

        return !includeDeniedChars;
      },
    ),
  [ContactInformationFields.BorrowerPhone]: Yup.string()
    .required('Phone is required')
    .test('isValidPhoneNumber', 'Invalid phone number', (value) => {
      if (!value) {
        return false;
      }
      return isValidPhoneNumber(value, {
        defaultCountry: 'US',
      });
    }),
  [ContactInformationFields.TelephoneAndElectronicCommunicationPolicy]: Yup.boolean().notRequired(),
});
